export class UserModel {
    constructor(
        public DisplayName: string = null,
        public Telephone: string = null,
        public MobilePhone: string = null,
        public Email: string= null,
    ) { }
}